import HttpClient from "../httpClient";
import { DefaultResponse, DefaultResponseContent, DefaultFilterRequest } from "../../models/types/common";
import { StationParameterWarningItem, StationParameterWarningFilter } from "../../models/types/stationParameterWarnings";

class StationParameterWarningsService {
    private service = HttpClient;

    async getAll(requestData: DefaultFilterRequest<StationParameterWarningFilter>): Promise<DefaultResponseContent<StationParameterWarningItem[]>> {
        const response = await this.service.get<DefaultResponseContent<StationParameterWarningItem[]>>("/admin/StationParameterWarnings/GetAll", requestData);
        return response;
    }

    async getLookup(): Promise<DefaultResponse<any[]>> {
        const response = await this.service.get<DefaultResponse<any[]>>("/admin/StationParameterWarnings/GetLookup");
        return response;
    }

    async getStationParameterWarningById(id: string): Promise<DefaultResponse<StationParameterWarningItem>> {
        const response = await this.service.get<DefaultResponse<StationParameterWarningItem>>(`/admin/StationParameterWarnings/GetDetail/${id}`);
        return response;
    }

    async createStationParameterWarning(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/StationParameterWarnings/Create`, requestData);
        return response;
    }

    async updateStationParameterWarning(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/StationParameterWarnings/Update`, requestData);
        return response;
    }

    async deleteStationParameterWarning(id: number | string): Promise<DefaultResponse<any>> {
        const response = await this.service.delete<DefaultResponse<any>>(`/admin/StationParameterWarnings/Delete/${id}`);
        return response;
    }

}

const stationParameterWarningsSvc = new StationParameterWarningsService();
export default stationParameterWarningsSvc;
